export default function TransmissionsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path
        d="M20.1666 11H16.4999L13.7499 19.25L8.24992 2.75L5.49992 11H1.83325"
        stroke="#FDFAEE"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
